<span class="ps-label">Projects:</span>

<div class="ps-trigger" [class.is-open]="open" (click)="toggleOpen()">
  <div class="ps-chips">
    @if (selectedProjects.length === 0) {
    <span class="ps-chip ps-chip--all">
      <span style="color: #434242">All Projects</span>
      <span class="ps-chip-count">{{ projects.length }}</span>
    </span>
    } @else {
    @for (p of selectedProjects; track p.id) {
    <span class="ps-chip">
      <span class="ps-chip-avatar" [class.has-logo]="p.logo"
        [style.background-color]="p.logo ? null : (p.color || '#5F42D9')">
        @if (p.logo) {
        <img [src]="p.logo" alt="" class="ps-chip-avatar-img" />
        } @else {
        <span class="ps-chip-avatar-initials">{{ getInitials(p.name) }}</span>
        }
      </span>
      <span class="ps-chip-name">{{ p.name }}</span>
      <button class="ps-chip-remove" type="button" (click)="removeSelection(p.id, $event)"
        aria-label="Remove project from selection">
        <lucide-icon name="x" [size]="12" style="display: flex;"></lucide-icon>
      </button>
    </span>
    }
    }
  </div>

  <lucide-icon name="chevron-down" [size]="15" class="ps-chevron" style="display: flex;"></lucide-icon>

  <button class="ps-close-mobile" type="button" aria-label="Close navigation"
    (click)="$event.stopPropagation(); mobileClose.emit()">
    <lucide-icon name="x" [size]="18" />
  </button>
</div>

<!-- Backdrop (closes on outside click) -->
@if (open) {
<div class="ps-backdrop" (click)="close()"></div>

<!-- Dropdown panel -->
<div class="ps-dropdown">

  <div class="ps-list">
    @for (p of sortedProjects; track p.id) {
    <div class="ps-item" [class.is-selected]="isSelected(p)" role="button" tabindex="0"
      (click)="toggleSelection(p, $event)" (keydown.enter)="toggleSelection(p, $event)">
      <div class="ps-item-avatar" [class.has-logo]="p.logo"
        [style.background-color]="p.logo ? null : (p.color || '#5F42D9')">
        @if (p.logo) {
        <img [src]="p.logo" alt="" class="ps-item-avatar-img" />
        } @else {
        <span class="ps-item-initials">{{ getInitials(p.name) }}</span>
        }
      </div>
      <span class="ps-item-name">{{ p.name }}</span>
      @if (isSelected(p)) {
      <lucide-icon name="check" [size]="14" class="ps-item-check" style="display: flex;"></lucide-icon>
      }
      <button class="ps-pin-btn" [class.is-pinned]="isPinned(p)" type="button" (click)="togglePin(p, $event)"
        [attr.aria-label]="isPinned(p) ? 'Unpin project' : 'Pin project'">
        <lucide-icon name="pin" [size]="14" style="display: flex;"></lucide-icon>
      </button>
    </div>
    }
  </div>

  <div class="ps-divider"></div>

  <!-- Footer actions -->
  <div class="ps-footer">
    <button class="ps-footer-item" type="button" (click)="openCreateProject()">
      <lucide-icon name="plus" [size]="15" style="display: flex;"></lucide-icon>
      <span>Create New Project</span>
    </button>
  </div>

</div>
}
